import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { FileCopyOutlined } from '@material-ui/icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import { showNotification } from '../../../actions/notificationActions';
import { liveEventStatusList } from '../../../constants/liveEventStatus';
import './LiveManagerTopHeader.scss';
import {
	getFormattedDate,
	convertSecondsToTimeStamp,
	getDifferenceBetweenTwodates,
} from '../../../services/timeStampService';
import LiveManagerTopPanel from '../../../components/LiveManagerTopPanel/LiveManagerTopPanel';
class LiveManagerTopHeader extends PureComponent {
	renderActionButton = () => {
		const { mediaId, mediaDetails, isVisible, t, isStreamPublished } = this.props;
		return (
			<>
				<LiveManagerTopPanel
					t={t}
					mediaId={mediaId}
					mediaDetails={mediaDetails}
					isVisible={isVisible}
					isStreamPublished={isStreamPublished}
					defaultEmails={this.props.defaultEmails}
				></LiveManagerTopPanel>
			</>
		);
	};

	renderEventIdentity = () => {
		const { t, mediaId, mediaDetails } = this.props;
		const title = mediaDetails?.title ?? '';
		if (!title && !mediaId) {
			return null;
		}
		return (
			<div className="liveEventIdentity">
				<label className="liveEventIdentity__title" title={title || undefined}>
					{title}
				</label>
				{mediaId && (
					<span className="liveEventIdentity__id">
						<label title={`${t('COMMON_MEDIA_ID')}: ${mediaId}`}>{mediaId}</label>
						<CopyToClipboard
							text={mediaId}
							onCopy={() =>
								this.props.showNotification(
									`${t('COMMON_MEDIA_ID')} ${t('COMMON_IS_COPIED')}!`
								)
							}
						>
							<IconButton
								className="liveEventIdentity__copyBtn"
								title={t('COMMON_CLICK_TO_COPY')}
								aria-label={t('COMMON_COPY')}
							>
								<FileCopyOutlined fontSize="small" />
							</IconButton>
						</CopyToClipboard>
					</span>
				)}
			</div>
		);
	};

	render() {
		const { t, liveEventStatus, liveEventStartTime, liveEventStopTime, duration } = this.props;
		return (
			<>
				<div id="liveManagerTopHeader">
					{this.renderActionButton()}
					{this.renderEventIdentity()}
					<ul>
						<li>
							<label>
								{' '}
								{liveEventStatus === liveEventStatusList.STARTED
									? t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_YOU_ARE_LIVE')
									: liveEventStatus === liveEventStatusList.STOPPED
									? t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_LIVE_ENDED')
									: t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_NOT_LIVE')}{' '}
							</label>
							<label> {t('COMMON_STATUS')} </label>
						</li>
						{liveEventStartTime && (
							<>
								<li>
									<label> {getFormattedDate(liveEventStartTime)} </label>
									<label> {t('COMMON_START')} </label>
								</li>
							</>
						)}

						{liveEventStatus === liveEventStatusList.STOPPED && (
							<>
								<li>
									<label> {getFormattedDate(liveEventStopTime)} </label>
									<label> {t('COMMON_STOP')} </label>
								</li>
							</>
						)}
						{liveEventStatus !== liveEventStatusList.INITIAL && (
							<li>
								{liveEventStartTime && liveEventStopTime ? (
									<label>
										{' '}
										{getDifferenceBetweenTwodates(liveEventStopTime, liveEventStartTime)}{' '}
									</label>
								) : (
									<label> {duration ? convertSecondsToTimeStamp(duration) : ''} </label>
								)}

								<label> {t('COMMON_DURATION')} </label>
							</li>
						)}
					</ul>
					<div className="liveHelp">
						<Button> {t('COMMON_HELP')} </Button>
					</div>
				</div>
			</>
		);
	}
}

const mapStateToProps = ({ liveManager }) => ({
	liveEventStatus: liveManager.liveEventStatus,
	liveEventStartTime: liveManager.liveEventStartTime,
	liveEventStopTime: liveManager.liveEventStopTime,
	liveStreamPositionTime: liveManager.liveStreamPositionTime,
	duration: liveManager.duration,
});

const mapDispatchToProps = (dispatch) => ({
	showNotification: (message) => dispatch(showNotification(message)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(LiveManagerTopHeader);
